import { render, staticRenderFns } from "./CompanyPageForm.vue?vue&type=template&id=40944136&scoped=true&"
import script from "./CompanyPageForm.vue?vue&type=script&lang=ts&"
export * from "./CompanyPageForm.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyPageForm.vue?vue&type=style&index=0&id=40944136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40944136",
  null
  
)

export default component.exports